<!-- src/components/Sources.vue -->
<template>
  <h4>Follow up questions</h4>
  <div v-if="suggestionsLoading" class="skeleton" aria-busy="true" aria-live="polite">
    <div class="skeleton-paragraph" role="status" aria-label="Loading suggested follow-on questions..."></div>
    <div class="skeleton-paragraph" role="status" aria-label="Loading suggested follow-on questions..."></div>
    <div class="skeleton-paragraph" role="status" aria-label="Loading suggested follow-on questions..."></div>
    <div class="skeleton-paragraph" role="status" aria-label="Loading suggested follow-on questions..."></div>
  </div>
  <div v-else>
    <div class="source-outer" v-if="Array.isArray(followOnQuestions) && followOnQuestions.length > 0">
      <div class="source" v-for="(question, index) in followOnQuestions" :key="index">
        <a href="#" class="follow-on-question" @click.prevent="askQuestion(question)">
          <span>{{ question }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { useQuestionStore } from '../store/questionStore';
import '@fortawesome/fontawesome-free/css/all.css';

export default defineComponent({
  setup() {
    const questionStore = useQuestionStore();

    const askQuestion = (question: string) => {
      questionStore.fetchAnswer(question);
    };

    return {
      askQuestion
    };
  },
  name: 'followOnQuestions',
  props: {
    followOnQuestions: {
      type: Array as PropType<Array<string>>,
      required: true,
      default: () => []
    },
    suggestionsLoading: {
      type: Boolean,
      required: true,
      default: false
    }
  }
});
</script>

<style scoped>
.source {
  padding: 5px 0 0 3px;
}

h4 {
  margin: 20px 0 -2px 0;
}

.skeleton {
  max-width: 18rem;
}

.skeleton-paragraph {
  height: 1rem;
  margin: 5px 0;
  background: #d0d0d0;
  border-radius: 5px;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    background-color: #d0d0d0;
  }

  50% {
    background-color: #f0f0f0;
  }

  100% {
    background-color: #d0d0d0;
  }
}
</style>
